import { ExtendedColumnDef } from "components/Datatable";
import type { IDepositStoresSummaryRow } from "src/@types/deposit-reconciliation";
import { StatusBadge } from "./components/status-badge";
import { ActionButton, DivergenceCell, MoneyCell } from "./components/cells";

export const columns: ExtendedColumnDef<IDepositStoresSummaryRow>[] = [
  {
    accessorKey: "storeCode",
    header: "Loja",
    cell: ({ row }) => `Loja ${row.original.storeCode} — ${row.original.storeName}`,
    className: "store-column",
  },
  {
    accessorKey: "responsibleName",
    header: "Responsável",
    cell: ({ row }) => row.original.responsibleName ?? "—",
    className: "responsible-column",
  },
  {
    accessorKey: "regionalName",
    header: "Regional",
    cell: ({ row }) => row.original.regionalName ?? "—",
    className: "region-column",
  },
  {
    accessorKey: "sumVar",
    header: "Σ VAR",
    headerAlignment: "center",
    cell: ({ row }) => <MoneyCell value={row.original.sumVar} />,
    className: "sells-column",
  },
  {
    accessorKey: "sumExtrato",
    header: "Σ Extrato",
    headerAlignment: "center",
    cell: ({ row }) => <MoneyCell value={row.original.sumExtrato} />,
    className: "deposit-column",
  },
  {
    accessorKey: "diferenca",
    header: "Divergência",
    headerAlignment: "center",
    cell: ({ row }) => <DivergenceCell value={row.original.diferenca} />,
    className: "divergence-column",
  },
  {
    accessorKey: "status",
    header: "Situação",
    headerAlignment: "center",
    cell: ({ row }) => (
      <div className="flex justify-center">
        <StatusBadge status={row.original.status} />
      </div>
    ),
    className: "status-column",
  },
  {
    id: "actions",
    header: () => <div>Ações</div>,
    cell: ({ row }) => (
      <div className="flex items-center justify-end px-2">
        <ActionButton store={row.original} />
      </div>
    ),
    className: "actions-column",
  },
];
